import {checkRequiredFields, validateFormInput} from "../../helper/tools";
import { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import {createEF, getDeceasedEfUserEmail} from "../../api/pro/deceasedReq";

export default function FormEFCreate({setShowModalEF, apiDeceasedInfos, correspondentInfos, adminInfos}) {
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const [message, setMessage] = useState({text: "", type: ""});
    const formRef = useRef();
    const [deceasedEfUserEmail, setDeceasedEfUserEmail] = useState("");
    const [values, setValues] = useState({efEmail: deceasedEfUserEmail || correspondentInfos?.email || adminInfos?.email || ""});

    const apiDeceasedEfUserEmail = async() => {
        const response = await getDeceasedEfUserEmail(id, token)
        setDeceasedEfUserEmail(response?.cadFamilleDeceased?.email)
    }

    const onChangeEfEmail = (e) => {
        setValues({...values, efEmail: e.target.value})
        validateFormInput(e)
    }

    const handleBack = () => {
        setShowModalEF(false)
    }

    useEffect(() => {
        apiDeceasedEfUserEmail();
    }, [id]);

    useEffect(() => {
        if (deceasedEfUserEmail) {
            setValues(prev => ({...prev, efEmail: deceasedEfUserEmail}));
        }
    }, [deceasedEfUserEmail]);

    const handleCreateEF = async (e) => {
        e.preventDefault()

        // Valider avec la référence du formulaire
        if (!checkRequiredFields(formRef.current)) {
            setMessage({text: "Veuillez remplir tous les champs requis.", type: "error"});
            return;
        }

        if (deceasedEfUserEmail && !window.confirm("Vous avez déjà créé l'accès à l'utilisateur. Si vous renvoyez le formulaire, son mot de passe sera regénéré.")) {
            return;
        }

        setMessage({text: "", type: ""});

        const submitEF = async (force = false) => {
            const localBody = {
                'deceased_id' : id,
                'user_email' : values?.efEmail,
                'force' : force,
            };

            const localResponse = await createEF(localBody, token);

            if (localResponse?.emailAlreadyUsed) {
                if (window.confirm(localResponse.warning)) {
                    const response = await submitEF(true);
                    if (!response?.success) {
                        setMessage({text: "L'utilisateur est déjà lié à ce défunt.", type: "error"});
                    }
                }
                return;
            }

            if (localResponse?.success) {
                setMessage({text: localResponse.success, type: "success"});
                setTimeout(() => {
                    setShowModalEF(false);
                    if (apiDeceasedInfos) {
                        apiDeceasedInfos();
                    }
                }, 2000);
            } else {
                const errorMsg = localResponse?.error || "Une erreur est survenue lors de la création de l'espace famille.";
                setMessage({text: errorMsg, type: "error"});
            }

            return localResponse;
        };

        await submitEF();
    }

    return(
        <form ref={formRef} onSubmit={handleCreateEF} method="post" noValidate>
            <legend>Création de l'espace famille</legend>
            <div className="form-input">
                <p>Un seul gestionnaire peut être désigné.</p> <p>Celui-ci pourra ensuite créer d’autres utilisateurs.</p>
                <label className="required">Un email sera envoyé au correspondant pour lui donner accès à l'espace famille</label>
                <input
                    required
                    value={values?.efEmail || ""}
                    type="email"
                    name="efEmail"
                    placeholder="Email du correspondant"
                    onChange={onChangeEfEmail}
                />

                {message?.text && (
                    <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
                        {message.text}
                    </div>
                )}
            </div>
            <div className="errors"></div>
            <div className="buttons-container back">
                <button type="button" className="blue-button" onClick={handleBack}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                <button type="submit" className="green-button"><i className="fa fa-plus"/><span>Créer l'espace famille</span></button>
            </div>
        </form>
    )
}